export const GOLFERS = [
    {
        name: "Abraham Ancer",
        position: 26,
        posQualifier: "T",
        rounds: [ 75,69,75,70],
        winnings: 79925,
    },
    {
        name: "Adam Scott",
        position: 54,
        posQualifier: "",
        rounds: [ 74,73,79,73],
        winnings: 26860,
    },
    {
        name: "Brooks Koepka",
        position: 55,
        posQualifier: "MC",
        rounds: [ 74,75,'-','-'],
        winnings: 10000,
    },
    {
        name: "Bryson DeChambeau",
        position: 46,
        posQualifier: "T",
        rounds: [ 76,67,75,75],
        winnings: 33503,
    },
    {
        name: "Cameron Smith",
        position: 10,
        posQualifier: "T",
        rounds: [ 74,68,73,70],
        winnings: 299000,
    },
    {
        name: "Collin Morikawa",
        position: 18,
        posQualifier: "T",
        rounds: [ 73,69,75,70],
        winnings: 161000,
    },
    {
        name: "Corey Conners",
        position: 8,
        posQualifier: "T",
        rounds: [ 73,69,68,74],
        winnings: 345000,
    },
    {
        name: "Daniel Berger",
        position: 55,
        posQualifier: "MC",
        rounds: [ 75,73,'-','-'],
        winnings: 10000,
    },
    {
        name: "Dustin Johnson",
        position: 55,
        posQualifier: "MC",
        rounds: [ 74,75,'-','-'],
        winnings: 10000,
    },
    {
        name: "Jason Day",
        position: 55,
        posQualifier: "MC",
        rounds: [ 77,76,'-','-'],
        winnings: 10000,
    },
    {
        name: "Joaquin Niemann",
        position: 40,
        posQualifier: "T",
        rounds: [ 75,71,70,76],
        winnings: 43700,
    },
    {
        name: "Jon Rahm",
        position: 5,
        posQualifier: "T",
        rounds: [ 72,72,72,66],
        winnings: 437000,
    },
    {
        name: "Jordan Spieth",
        position: 3,
        posQualifier: "T",
        rounds: [ 71,68,72,70],
        winnings: 667000,
    },
    {
        name: "Justin Thomas",
        position: 21,
        posQualifier: "T",
        rounds: [ 73,67,75,73],
        winnings: 119600,
    },
    {
        name: "Matt Kuchar",
        position: 55,
        posQualifier: "MC",
        rounds: [ 78,70,'-','-'],
        winnings: 10000,
    },
    {
        name: "Matthew Wolff",
        position: 55,
        posQualifier: "DQ",
        rounds: [ 76,79,'-','-'],
        winnings: 10000,
    },
    {
        name: "Patrick Cantlay",
        position: 55,
        posQualifier: "MC",
        rounds: [ 79,73,'-','-'],
        winnings: 10000,
    },
    {
        name: "Patrick Reed",
        position: 8,
        posQualifier: "T",
        rounds: [ 70,75,70,69],
        winnings: 345000,
    },
    {
        name: "Paul Casey",
        position: 26,
        posQualifier: "T",
        rounds: [ 73,74,73,69],
        winnings: 79925,
    },
    {
        name: "Rory McIlroy",
        position: 55,
        posQualifier: "MC",
        rounds: [ 76,74,'-','-'],
        winnings: 10000,
    },
    {
        name: "Sergio Garcia",
        position: 55,
        posQualifier: "MC",
        rounds: [ 76,72,'-','-'],
        winnings: 10000,
    },
    {
        name: "Sungjae Im",
        position: 55,
        posQualifier: "MC",
        rounds: [ 77,80,'-','-'],
        winnings: 10000,
    },
    {
        name: "Tommy Fleetwood",
        position: 46,
        posQualifier: "T",
        rounds: [ 74,70,73,76],
        winnings: 33503,
    },
    {
        name: "Tony Finau",
        position: 10,
        posQualifier: "T",
        rounds: [ 74,66,73,72],
        winnings: 299000,
    },
    {
        name: "Viktor Hovland",
        position: 21,
        posQualifier: "T",
        rounds: [ 73,70,72,73],
        winnings: 119600,
    },
    {
        name: "Webb Simpson",
        position: 12,
        posQualifier: "T",
        rounds: [ 70,76,70,70],
        winnings: 218500,
    },
    {
        name: "Xander Schauffele",
        position: 3,
        posQualifier: "T",
        rounds: [ 72,69,68,72],
        winnings: 667000,
    },
]
